<div class="card-header">
  <div class="card-title">
    <ng-content select="[cardTitle]"></ng-content>
  </div>
  <div class="card-badge">
    <ng-content select="[cardBadge]"></ng-content>
  </div>
  <div class="card-menu">
    <ng-content select="[cardMenu]"></ng-content>
  </div>
</div>

<div class="card-body">
  <ng-content select="[cardBody]"></ng-content>
</div>

<div class="card-footer">
  <ng-content select="[cardFooter]"></ng-content>
</div>

<ng-content select="[cardOverlay]"></ng-content>
